import api from '../../services/api'

export default {
  state: {
    session: {
      token: localStorage.getItem('token') || '',
      user: {
        id: localStorage.getItem('id') || '',
        name: localStorage.getItem('name') || '',
        username: localStorage.getItem('username') || '',
        type: localStorage.getItem('type') || ''
      }
    },
    userNeedsAcceptConsentTerm: false
  },
  getters: {
    session(state) {
      return state.session
    },
    isLoggedIn(state) {
      return !!state.session.token
    },
    userNeedsAcceptConsentTerm(state) {
      return state.userNeedsAcceptConsentTerm
    }

  },
  mutations: {
    setSession(state, session) {
      state.session = session
    },
    clearSession(state) {
      state.session.token = ''
      state.session.user.id = ''
      state.session.user.name = ''
      state.session.username = ''
      state.session.type = ''
    },
    setUserNeedsAcceptConsentTerm(state, trueFalse) {
      state.userNeedsAcceptConsentTerm = trueFalse
    }
  },
  actions: {
    session({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)

      let sessionPayload = {
        username: payload.username.trim(), // This remove whitespace characters from the start and end of a string
        password: payload.password
      }

      if (payload.accepted_consent_term) {
        sessionPayload = {
          ...sessionPayload,
          accepted_consent_term: payload.accepted_consent_term
        }
      }

      return new Promise((resolve, reject) => {
        api
          .post('session/', sessionPayload)
          .then(result => {
            if (!result.data.user.accepted_consent_term) {
              commit('setUserNeedsAcceptConsentTerm', true)
              const error = {
                data: {
                  error: 'You must agree to continue'
                }
              }
              commit('setError', error)
              reject(Error(error.data.error))
            } else {
              localStorage.setItem('username', result.data.user.username)
              localStorage.setItem('name', result.data.user.name)
              localStorage.setItem('id', result.data.user.id)
              localStorage.setItem('type', result.data.user.type)
              localStorage.setItem('token', result.data.token)
              commit('setUserNeedsAcceptConsentTerm', false)
              commit('setSession', result.data)
              resolve(result.data)
            }
          })
          .catch(err => {
            localStorage.removeItem('token')
            commit('setError', err.response || err)
            try {
              reject(err.response.data.error)
            } catch (e) {
              reject(err)
            }
          })
          .finally(() => commit('setLoading', false))
      })
    },
    logOff({ commit }) {
      commit('clearError')
      return new Promise((resolve, reject) => {
        let tourFinalized = localStorage.getItem('tourFinalized')
        let showUpdateDialog = localStorage.getItem('show_update_dialog')
        localStorage.clear()
        if (tourFinalized) {
          localStorage.setItem('tourFinalized', tourFinalized)
        }
        if (showUpdateDialog) {
          localStorage.setItem('show_update_dialog', showUpdateDialog)
        }

        commit('clearSession')
        resolve()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/session/index.js